import { provideMirroredSuperProperties } from "src/app/shared/services/gtm-super-property-mirror.service";
import {
  TH_LANDING_EXPERIMENT_KEY,
  isLandingVariant,
} from "./th-landing-variant-test.model";

/** Keeps GTM attribution aligned with Mixpanel, accepting only a complete enrolled cohort. */
export const provideThLandingGtmLabels = () =>
  provideMirroredSuperProperties({
    names: ["lp_experiment", "lp_variant"],
    isMirrorable: (values: Record<string, unknown>) =>
      values["lp_experiment"] === TH_LANDING_EXPERIMENT_KEY &&
      isLandingVariant(values["lp_variant"]),
  });
